import { URLManager } from './URLManager';

export const closeMenuAndUpdateUrl = (projectIdentifier: string) => {
  const urlManager = URLManager.getInstance();
  urlManager.updateURL(
    projectIdentifier,
    'network',
    'editor',
    'auto',
    'menu_close'
  );
}; 